import { Controller } from '@hotwired/stimulus'
import { v4 as uuidv4 } from 'uuid'
import {
  trans,
  DOWNLOAD,
  GENERATING,
  TRY_AGAIN_LATER
} from '../../translator'

export default class RecordPrintingController extends Controller {
  clientPrintRequestId: string

  static values = {
    recordId: String,
    recordType: String
  }

  declare recordIdValue: string
  declare recordTypeValue: string

  static targets = ['includeHistory', 'includeLinked', 'printButton', 'printText', 'printIcon', 'printSpinner', 'downloadIframe']

  declare readonly hasIncludeHistoryTarget: boolean
  declare readonly includeHistoryTarget: HTMLInputElement
  declare readonly hasIncludeLinkedTarget: boolean
  declare readonly includeLinkedTarget: HTMLInputElement
  declare readonly printButtonTarget: HTMLButtonElement
  declare readonly printTextTarget: HTMLDivElement
  declare readonly printIconTarget: HTMLElement
  declare readonly printSpinnerTarget: HTMLElement
  declare readonly downloadIframeTarget: HTMLIFrameElement

  connect () {
    this.clientPrintRequestId = sessionStorage.getItem('clientRecordPrintRequestId')
    if (!this.clientPrintRequestId) {
      this.clientPrintRequestId = uuidv4()
      sessionStorage.setItem('clientRecordPrintRequestId', this.clientPrintRequestId)
    }
    document.addEventListener('MercureEvent', this.handleMercureEvent.bind(this))
  }

  disconnect () {
    document.removeEventListener('MercureEvent', this.handleMercureEvent.bind(this))
  }

  handleMercureEvent (event) {
    const data = event.detail.data

    if (data.clientRequestId && data.clientRequestId === this.clientPrintRequestId) {
      if (data.event === 'fileGeneratedEvent' && data.downloadUrl) {
        this.enablePrintButton()
        this.downloadIframeTarget.setAttribute('src', data.downloadUrl)
      } else if (data.event === 'fileGenerationErrorEvent') {
        this.errorPrintButton()
      }
    }
  }

  print () {
    const urlRootPath = this.recordTypeValue.toLowerCase()
    let url = `/${urlRootPath}/print/${this.recordIdValue}?clientRequestId=${this.clientPrintRequestId}`

    if (this.hasIncludeHistoryTarget && this.includeHistoryTarget.checked) {
      url += '&includeHistory=true'
    }
    if (this.hasIncludeLinkedTarget && this.includeLinkedTarget.checked) {
      url += '&includeLinked=true'
    }

    this.loadingPrintButton()

    fetch(url)
      .then((response) => {
        if (response.status === 403) {
          window.location.reload()
        } else if (!response.ok) {
          throw new Error()
        }
      })
      .catch(() => {
        this.errorPrintButton()
      })
  }

  enablePrintButton () {
    this.printButtonTarget.disabled = false
    this.printTextTarget.innerText = trans(DOWNLOAD, {}, 'actions')
    this.printIconTarget.classList.remove('d-none')
    this.printSpinnerTarget.classList.add('d-none')
  }

  loadingPrintButton () {
    this.printButtonTarget.disabled = true
    this.printTextTarget.innerText = trans(GENERATING, {}, 'records')
    this.printIconTarget.classList.add('d-none')
    this.printSpinnerTarget.classList.remove('d-none')
  }

  errorPrintButton () {
    this.printButtonTarget.disabled = true
    this.printTextTarget.innerText = trans(TRY_AGAIN_LATER, {}, 'records')
    this.printSpinnerTarget.classList.add('d-none')
    this.printIconTarget.classList.add('d-none')
    setTimeout(() => {
      this.enablePrintButton()
    }, 10000)
  }
}
